export { VerifyTin } from './VerifyTin';
